@if (!loading && rules.length > 0) {
  <div class="rules-container">
    <div class="rules-header">
      <mat-icon>rule</mat-icon>
      <span class="rules-title">{{ "RULES" | translate }}</span>
    </div>
    <div class="rules-content">
      <!-- <div *ngIf="!loading && rules.length === 0">{{ "NO_RULES" | translate }}</div> -->
      @for (rule of rules; track rule) {
        <div class="rule-card">
          <strong>{{ rule.subject }}</strong>
          <p>{{ rule.description }}</p>
        </div>
      }
    </div>
  </div>
}